/* eslint-disable */
import { useMemo, useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import VariantTable from '@/Pages/Food Products/VariantPrice/VariantTable';
import { getSelectedStoreName, shortMonthNames } from './helperPriceUpdate';
import GlobalSearch from '@/Components/globalSearch/search';
import { getHigherUnitName } from '@/Helpers';

function ReviewAndSummarize(props) {
	const { data, setNextStep = null, selectedStore = null, storeList = [], showPrevMonth = false, setShowPrevMonth = () => { } } = props;
	const storeName = getSelectedStoreName(selectedStore, storeList);
	const date = new Date();
	const month = data?.[0]?.changeMonth ?? (date.getMonth() === 0 ? 11 : date.getMonth() - 1);
	const currentYear = date.getMonth() === 0 ? date.getFullYear() - 1 : date.getFullYear(); 
	const reportingInfo = `${shortMonthNames[month]} ${currentYear}`;
	const [searchValue, setSearchValue] = useState('');

	const monthsColumns = useMemo(() => {
		const currentMonth = new Date().getMonth();
		const currentYear = currentMonth === 0 ? new Date().getFullYear() - 1 : new Date().getFullYear();
		return [
			{
				title: 'Item Name', key: 'itemName',
			},
			{
				title: 'SKU Code', key: 'skuCode',
			},
			{
				title: `Old Price (${shortMonthNames[month]} ${currentYear})`, key: `oldPrice_${month}`,
			},
			{
				title: `New Price (${shortMonthNames[month]} ${currentYear})`, key: `newPrice_${month}`,
			},
		];
	}, [month]);


	const customRowData = useMemo(() => {
		return {
			itemName: (product) => (
				<div className='text-gray-700 text-left text-[12px]'>{product?.itemName}</div>
			),
			skuCode: (product) => (
				<div className='text-gray-700 text-left text-[12px]'>{product?.skuCode}</div>
			),
			[`oldPrice_${month}`]: (product) => (
				<div className='text-gray-700 text-left text-[12px]'>{product?.[`oldPrice_${month}`]} ₹/{getHigherUnitName(product?.unit)}</div>
			),
			[`newPrice_${month}`]: (product) => {
				return <div className='text-gray-700 text-left text-[12px]'>{product?.[`newPrice_${month}`]} ₹/{getHigherUnitName(product?.unit)}</div>
			},
		}
	}, [month]);

	const customCol = (column) => {
		return (
			<div className='text-gray-700 text-left text-nowrap text-[12px] font-medium'>
				{column?.title}
			</div>
		);
	};

	const getFilteredData = useMemo(() => {
		if (!searchValue) return data;
		return data.filter((item) => item?.itemName?.toLowerCase().includes(searchValue?.toLowerCase()) || item?.skuCode?.toLowerCase().includes(searchValue?.toLowerCase()));
	}, [data, searchValue]);

	return (
		<div className='flex flex-col h-full w-full'>
			<div className='flex items-center justify-start px-4 py-2 bg-white border-b border-gray-200 gap-3 shadow-sm mb-4'>
				<button
					className='flex items-center justify-center rounded-full hover:bg-gray-100 transition p-1 mr-2'
					title='Back'
					onClick={() => {
						setNextStep(0);
						setShowPrevMonth(false);
					}}
				>
					<ArrowLeft size={22} className='text-gray-700' />
				</button>	
				<div className='flex flex-row items-center w-full gap-3'>
					<div className='text-lg font-semibold text-gray-900'>{storeName}</div>
					<div className='px-3 py-1 rounded-md bg-yellow-100 text-yellow-700 text-sm font-medium border border-yellow-300'>
						{reportingInfo}
					</div>
					<div className='flex-1 min-w-0 max-w-full flex items-center'>
						<GlobalSearch
							placeholderText='Search by Item Name or SKU Code'
							setSearchValue={setSearchValue}
							searchDropDown={false}
						/>
					</div>
				</div>
			</div>
			<div className='flex-1 w-full overflow-auto rounded-xl bg-white px-2 pb-2 h-[calc(100vh-220px)]'>
				<VariantTable
					columns={monthsColumns}
					data={getFilteredData}
					customRowData={customRowData}
					customCol={customCol}
				/>
			</div>
		</div>
	);
}
export default ReviewAndSummarize;
